import { usePushNotifications } from '@/hooks/usePushNotifications';

/**
 * Renders nothing; exists so usePushNotifications (which needs useAuth) can
 * run inside AuthProvider from the root layout. No-op on web via the
 * lib/pushNotifications.web.ts stub.
 */
export function PushNotificationsBridge() {
  usePushNotifications();
  return null;
}
